import { createIsMatchRegex } from '~teacher/util/regexHelpers/createIsMatchRegex';
export const isAustraliaOrNewZealandOrUK = createIsMatchRegex(
  /^(australia|united kingdom|new zealand)$/i
);
